import {useEffect, useState} from 'react'
import { DropDownList,ComboBox  } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

//component AssetDropDown
export const AssetDropDown = (props) => {
    const{popupSettings,onClose,...rest}=props;
    const initialValue=props.value;
    const [AssestList,SetAssestList] =useState(props.data);
    const [value,setValue]=useState(initialValue);

    const filteredData = (filter) => {
        const filtered = filterBy(props.data, filter);
        return filtered.sort((a, b) => a.AssetName.localeCompare(b.AssetName));
    };
    
    const filterChange = async (event) => {
        const filtered = filteredData(event.filter);
        SetAssestList([...filtered].sort((a, b) => a.AssetName.localeCompare(b.AssetName)));
    };
    useEffect(() => {
        SetAssestList([...props.data].sort((a, b) => a.AssetName.localeCompare(b.AssetName)));
    }, []);

    useEffect(()=>{
      setValue(initialValue);
    },[]);

    useEffect(()=>{
      setValue(props.value);
    },[initialValue]);

    const kendoDropdownChanged =(e)=>{
      setValue(e.value);
      props.onChange && props.onChange(e);
    }
    const KeyDownEvent=(e)=>{
      if (e.keyCode === 13)
      {
        alert('enter key pressed');
      }
    }
  return (
    <div>
        <ComboBox data={AssestList}
         textField="AssetName" 
         dataItemKey="AssetId" 
         onChange={kendoDropdownChanged}
         filterable={true}
         clearButton={false}
         onFilterChange={filterChange}
         value={value}
         className={`${props.className} SBADropDown`}
         disabled={props.disabled || false}
         popupSettings={popupSettings}
         onClose={onClose}
         >
         </ComboBox>
    </div>
  )
 }
